import {
	Autocomplete,
	Button,
	Paper,
	Table,
	TableBody,
	TableCell,
	TableHead,
	TableRow,
	TextField,
	ThemeProvider,
	createTheme,
	useMediaQuery,
	IconButton,
} from "@mui/material"
import DeleteIcon from "@mui/icons-material/Delete"
import AddIcon from "@mui/icons-material/Add"
import { useContext, useEffect, useState } from "react"
import { adminGetDescriptions, adminUpdateDescriptions, getModelTreeV2 } from "../util/firebase"
import { AdminContext } from "../views/Admin"

const mdTheme = createTheme({
	palette: {
		primary: {
			main: "#132242",
		},
		secondary: {
			main: "#DF0A0A",
		},
		white: {
			main: "white",
		},
	},
	direction: "rtl",
})

const Descriptions = () => {
	const adminContext = useContext(AdminContext)
	const handleOpenSnackbar = adminContext.handleOpenSnackbar

	const matches = useMediaQuery(mdTheme.breakpoints.up("md"))
	const [models, setModels] = useState([])
	const [make, setMake] = useState(null)
	const [model, setModel] = useState(null)
	const [descriptions, setDescriptions] = useState([])
	const [modelTree, setModelTree] = useState([])

	useEffect(() => {
		const _getModelTree = async () => {
			const response = await getModelTreeV2()
			setModelTree(response.data)
		}
		_getModelTree()
	}, [])

	useEffect(() => {
		if (modelTree?.length > 0 && make?.length > 0) {
			const _modelsFromTree = []
			modelTree
				.filter((key) => key.name === make)[0]
				.models.forEach((modelFromTree) => {
					_modelsFromTree.push(modelFromTree.label)
				})
			setModels(_modelsFromTree)
		} else if (!make) {
			setModels([])
		}
	}, [make, modelTree])

	useEffect(() => {
		const _getDescriptions = async () => {
			const response = await adminGetDescriptions({ make: make, model: model })
			if (response.data.status === 0) {
				setDescriptions(response.data.descriptions)
			}
		}

		if (make?.length > 0 && model?.length > 0) {
			_getDescriptions()
		} else if (!model) {
			setDescriptions([])
		}
	}, [make, model])

	const handleAddDescription = () => {
		setDescriptions((prevState) => [...prevState, { id: `NEW-${prevState.length}` }])
	}

	const handleDeleteDescription = (index) => {
		const _newState = descriptions.map((description, i) => {
			if (index === i) {
				return { ...description, delete: true }
			} else {
				return { ...description }
			}
		})
		setDescriptions(_newState)
	}

	const handleUpdateDescriptions = async () => {
		console.log(descriptions)

		try {
			const response = await adminUpdateDescriptions({
				make: make,
				model: model,
				descriptions: descriptions,
			})
			if (response.data.status === 0) {
				setDescriptions(response.data.descriptions)
				handleOpenSnackbar("תאורי רכב עודכנו בהצלחה", "success")
			} else {
				handleOpenSnackbar("תקלה בעידכון תאורי רכב", "error")
			}
		} catch (e) {
			console.log(e)
			handleOpenSnackbar("תקלה בעידכון תאורי רכב", "error")
		}
	}

	return (
		<ThemeProvider theme={mdTheme}>
			<Paper sx={{ p: 2, display: "flex", flexDirection: "column", mb: 2 }}>
				<div style={{ display: "flex", flexDirection: matches ? "row" : "column" }}>
					<Autocomplete
						disablePortal
						options={modelTree
							.sort((a, b) => a.name.localeCompare(b.name))
							.map((key) => ({
								label: key.name,
								id: key.name,
							}))}
						renderInput={(params) => <TextField {...params} label="יצרן" />}
						size="small"
						sx={{ width: "100%", pb: 2, pt: 1 }}
						onChange={(event, newValue) => {
							setMake(newValue?.id ?? null)
							setModel(null)
						}}
						isOptionEqualToValue={(option, value) => option.id === value.id}
					/>
					<Autocomplete
						disablePortal
						options={models?.sort().map((key) => ({
							label: key,
							id: key,
						}))}
						value={model?.length > 0 ? { id: model, label: model } : null}
						renderInput={(params) => <TextField {...params} label="דגם" />}
						size="small"
						sx={{ width: "100%", pb: 2, pt: 1 }}
						onChange={(event, newValue) => {
							setModel(newValue?.id ?? null)
						}}
						isOptionEqualToValue={(option, value) => option.id === value.id}
					/>
				</div>
				{matches ? (
					<>
						<Table sx={{ mt: 2 }}>
							<TableHead>
								<TableRow>
									<TableCell>משנה</TableCell>
									<TableCell sx={{ whiteSpace: "nowrap" }}>עד שנה</TableCell>
									<TableCell>תיאור</TableCell>
									<TableCell>מחיקה</TableCell>
								</TableRow>
							</TableHead>
							<TableBody>
								{descriptions
									.sort((a, b) => a.fromYear - b.fromYear)
									.map((description, i) => {
										if (!description.delete) {
											return (
												<TableRow
													sx={{ "&:last-child td, &:last-child th": { border: 0 }, verticalAlign: "top" }}
													key={description.id}
												>
													<TableCell>
														<TextField
															label={"משנה"}
															value={description?.fromYear ?? ""}
															onChange={(e) => {
																setDescriptions((prevState) => {
																	const newState = [...prevState]
																	newState[i] = { ...newState[i], fromYear: parseInt(e.target.value) }
																	return newState
																})
															}}
															fullWidth={!matches}
															sx={{ mb: matches ? 0 : 2, mr: matches ? 2 : 0, maxWidth: "80px", minWidth: "80px" }}
															size="small"
														/>
													</TableCell>
													<TableCell>
														<TextField
															label={"עד שנה"}
															value={description?.toYear ?? ""}
															onChange={(e) => {
																setDescriptions((prevState) => {
																	const newState = [...prevState]
																	newState[i] = { ...newState[i], toYear: parseInt(e.target.value) }
																	return newState
																})
															}}
															fullWidth={!matches}
															sx={{ mb: matches ? 0 : 2, mr: matches ? 2 : 0, maxWidth: "80px", minWidth: "80px" }}
															size="small"
														/>
													</TableCell>
													<TableCell>
														<TextField
															label={"תיאור"}
															value={description.description ?? ""}
															onChange={(e) => {
																setDescriptions((prevState) => {
																	const newState = [...prevState]
																	newState[i] = { ...newState[i], description: e.target.value }
																	return newState
																})
															}}
															fullWidth={!matches}
															rows={10}
															multiline
															sx={{ mb: matches ? 0 : 2, mr: matches ? 2 : 0, minWidth: "550px", width: "100%" }}
															size="small"
														/>
													</TableCell>
													<TableCell>
														<IconButton
															onClick={() => {
																handleDeleteDescription(i)
															}}
														>
															<DeleteIcon />
														</IconButton>
													</TableCell>
												</TableRow>
											)
										} else {
											return null
										}
									})}
								{make && model && (
									<TableRow sx={{ "&:last-child td, &:last-child th": { border: 0 }, verticalAlign: "top" }}>
										<TableCell colSpan={4}>
											<IconButton
												onClick={() => {
													handleAddDescription()
												}}
											>
												<AddIcon />
											</IconButton>
										</TableCell>
									</TableRow>
								)}
							</TableBody>
						</Table>
						{descriptions?.length > 0 && (
							<Button
								sx={{
									m: 2,
									width: matches ? "120px" : "auto",
									backgroundColor: mdTheme.palette.secondary.main,
									"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
									maxHeight: "36px",
								}}
								variant="contained"
								onClick={() => handleUpdateDescriptions()}
							>
								שמירה
							</Button>
						)}
					</>
				) : (
					<>
						{descriptions
							.sort((a, b) => a.fromYear - b.fromYear)
							.map((description, i) => {
								if (!description.delete) {
									return (
										<Paper sx={{ p: 2, display: "flex", flexDirection: "column", mb: 2 }} key={description.id}>
											<Table sx={{ tableLayout: "fixed", mt: 2 }}>
												<TableBody>
													<TableRow>
														<TableCell variant="head" sx={{ fontWeight: 600 }}>
															משנה
														</TableCell>
														<TableCell>
															<TextField
																label={"משנה"}
																value={description?.fromYear ?? ""}
																onChange={(e) => {
																	setDescriptions((prevState) => {
																		const newState = [...prevState]
																		newState[i] = { ...newState[i], fromYear: parseInt(e.target.value) }
																		return newState
																	})
																}}
																fullWidth={!matches}
																sx={{ mb: matches ? 0 : 2, mr: matches ? 2 : 0, maxWidth: "80px", minWidth: "80px" }}
																size="small"
															/>
														</TableCell>
													</TableRow>
													<TableRow>
														<TableCell variant="head" sx={{ fontWeight: 600 }}>
															עד שנה
														</TableCell>
														<TableCell sx={{ wordWrap: "break-word" }}>
															<TextField
																label={"עד שנה"}
																value={description?.toYear ?? ""}
																onChange={(e) => {
																	setDescriptions((prevState) => {
																		const newState = [...prevState]
																		newState[i] = { ...newState[i], toYear: parseInt(e.target.value) }
																		return newState
																	})
																}}
																fullWidth={!matches}
																sx={{ mb: matches ? 0 : 2, mr: matches ? 2 : 0, maxWidth: "80px", minWidth: "80px" }}
																size="small"
															/>
														</TableCell>
													</TableRow>
													<TableRow>
														<TableCell variant="head" sx={{ fontWeight: 600 }}>
															תיאור
														</TableCell>
														<TableCell>
															<TextField
																label={"תיאור"}
																value={description.description ?? ""}
																onChange={(e) => {
																	setDescriptions((prevState) => {
																		const newState = [...prevState]
																		newState[i] = { ...newState[i], description: e.target.value }
																		return newState
																	})
																}}
																fullWidth={!matches}
																rows={10}
																multiline
																sx={{
																	mb: matches ? 0 : 2,
																	mr: matches ? 2 : 0,
																	/* minWidth: "550px", */ width: "100%",
																}}
																size="small"
															/>
														</TableCell>
													</TableRow>
													<TableRow>
														<TableCell variant="head" sx={{ fontWeight: 600 }}>
															מחיקה
														</TableCell>
														<TableCell>
															<IconButton
																onClick={() => {
																	handleDeleteDescription(i)
																}}
															>
																<DeleteIcon />
															</IconButton>
														</TableCell>
													</TableRow>
												</TableBody>
											</Table>
										</Paper>
									)
								} else {
									return null
								}
							})}
						{make && model && (
							<Paper sx={{ p: 2, display: "flex", flexDirection: "column", mb: 2 }}>
								<IconButton
									onClick={() => {
										handleAddDescription()
									}}
								>
									<AddIcon />
								</IconButton>
							</Paper>
						)}
						{descriptions?.length > 0 && (
							<Button
								sx={{
									m: 2,
									width: matches ? "120px" : "auto",
									backgroundColor: mdTheme.palette.secondary.main,
									"&:hover": { backgroundColor: mdTheme.palette.secondary.main },
									maxHeight: "36px",
								}}
								variant="contained"
								onClick={() => handleUpdateDescriptions()}
							>
								שמירה
							</Button>
						)}
					</>
				)}
			</Paper>
		</ThemeProvider>
	)
}

export default Descriptions
